<template>
  <div class="animated fadeIn">
    <loader v-if="loading"></loader>
    <div v-if="!loading">
      <b-row>
        <b-col md="6">
          <div class="text-left"><h4>Subscription plan details</h4></div>
        </b-col>
        <b-col md="6"
          ><div slot="text-right">
            <eb-button
              style="color: white; font-weight: bold; float: right"
              text="Back"
              @click="(e) => $emit('view', e)"
            ></eb-button></div
        ></b-col>
        <b-col md="12">
          <div class="mt-3">
            <b-row class="mb-3">
              <b-col md="6">
                <v-card style="border-radius: 16px" height="240">
                  <div class="m-2 p-2">
                    <h4 style="color: #727cf5">General</h4>
                    <b-row>
                      <b-col md="6">
                        <b-row>
                          <b-col md="7">
                            <h4 class="planDetailHeading">Name:</h4>
                          </b-col>
                          <b-col md="5">
                            <h5 class="plandetailResult">
                              {{ inputObject.planName }}
                            </h5>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col md="7">
                            <h4 class="planDetailHeading">org Access Level:</h4>
                          </b-col>
                          <b-col md="5">
                            <h5 class="plandetailResult">
                              {{ inputObject.orgAccessLevel.label }}
                            </h5>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col md="7">
                            <h4 class="planDetailHeading">Description:</h4>
                          </b-col>
                          <b-col md="5">
                            <h5 class="plandetailResult">
                              {{ inputObject.description }}
                            </h5>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col md="6">
                        <b-row>
                          <b-col md="4">
                            <h4 class="planDetailHeading">Scope:</h4>
                          </b-col>
                          <b-col md="8">
                            <h5 class="plandetailResult">
                              {{ inputObject.scope.label }}
                            </h5>
                          </b-col>
                        </b-row>
                        <div
                          v-if="
                            inputObject.orgAccessLevel &&
                            inputObject.orgAccessLevel.value === 'LIMITED'
                          "
                        >
                          <b-row>
                            <b-col md="7">
                              <h4 class="planDetailHeading">
                                org Access Level:
                              </h4>
                            </b-col>
                            <b-col md="5">
                              <h5
                                class="plandetailResult"
                                v-for="(org, idx) in inputObject.orgAccessList"
                                :key="idx"
                              >
                                {{ org.name }}
                              </h5>
                            </b-col>
                          </b-row>
                        </div>
                      </b-col>
                    </b-row>
                    <!-- <b-row class="mb-n4">
                      <b-col md="6">
                        <b-row>
                          <b-col md="4">
                            <h4>Name:</h4>
                          </b-col>
                          <b-col md="8">
                            <h5 class="  ml-n4">
                              {{ inputObject.planName }}
                            </h5>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col md="6">
                        <b-row>
                          <b-col md="4">
                            <h4>Scope:</h4>
                          </b-col>
                          <b-col md="8">
                            <h5 class="  ml-n4">
                              {{ inputObject.scope.label }}
                            </h5>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row class="mb-n4">
                      <b-col md="6">
                        <b-row>
                          <b-col md="7">
                            <h4>org Access Level:</h4>
                          </b-col>
                          <b-col md="5">
                            <h5 class="  ml-n4">
                              {{ inputObject.orgAccessLevel.label }}
                            </h5>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col md="6">
                        <div
                          v-if="
                            inputObject.orgAccessLevel &&
                              inputObject.orgAccessLevel.value === 'LIMITED'
                          "
                        >
                          <b-row>
                            <b-col md="7">
                              <h4>org Access Level:</h4>
                            </b-col>
                            <b-col md="5">
                              <h5
                                class="  ml-n4"
                                v-for="(org, idx) in inputObject.orgAccessList"
                                :key="idx"
                              >
                                {{ org.name }}
                              </h5>
                            </b-col>
                          </b-row>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="mb-n3">
                      <b-col md="3">
                        <h4>Description:</h4>
                      </b-col>
                      <b-col md="9">
                        <h5 class="  ml-n4">
                          {{ inputObject.description }}
                        </h5>
                      </b-col>
                    </b-row> -->
                  </div>
                </v-card>
              </b-col>
              <b-col md="6">
                <v-card height="240" style="border-radius: 16px">
                  <div class="m-2 p-3">
                    <h4 style="color: #727cf5">Pricing</h4>
                    <b-row>
                      <b-col md="6">
                        <b-row>
                          <b-col md="7">
                            <h4 class="planDetailHeading">Payment Type:</h4>
                          </b-col>
                          <b-col md="5">
                            <h5 class="plandetailResult">
                              {{ inputObject.paymentType.label }}
                            </h5>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col md="6">
                        <b-row>
                          <b-col md="5">
                            <h4 class="planDetailHeading">Tax Code:</h4>
                          </b-col>
                          <b-col md="7">
                            <h5 class="plandetailResult">
                              {{ inputObject.taxCode.label }}
                            </h5>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="6">
                        <b-row>
                          <b-col md="7">
                            <h4 class="planDetailHeading">Charge Code:</h4>
                          </b-col>
                          <b-col md="5">
                            <h5 class="plandetailResult">
                              {{ inputObject.chargeCode }}
                            </h5>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col md="6">
                        <b-row>
                          <b-col md="5">
                            <h4 class="planDetailHeading">Currency:</h4>
                          </b-col>
                          <b-col md="7">
                            <h5 class="plandetailResult">
                              {{ inputObject.currency }}
                            </h5>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="6">
                        <b-row>
                          <b-col md="7">
                            <h4 class="planDetailHeading">Price:</h4>
                          </b-col>
                          <b-col md="5">
                            <h5 class="plandetailResult">
                              {{ inputObject.price }}
                            </h5>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col md="6">
                        <div v-if="inputObject.cadencetype.value === 'EVENT'">
                          <b-row>
                            <b-col md="5">
                              <h4 class="planDetailHeading">Event:</h4>
                            </b-col>
                            <b-col md="7">
                              <h5 class="plandetailResult">
                                {{ inputObject.eventType.label }}
                              </h5>
                            </b-col>
                          </b-row>
                        </div>
                        <b-row>
                          <b-col md="7">
                            <h4 class="planDetailHeading">Base Quantity:</h4>
                          </b-col>
                          <b-col md="5">
                            <h5 class="plandetailResult">
                              {{ inputObject.baseQuantity }}
                            </h5>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="6">
                        <b-row>
                          <b-col md="7">
                            <h4 class="planDetailHeading">Cadence Type:</h4>
                          </b-col>
                          <b-col md="5">
                            <h5 class="plandetailResult">
                              {{ inputObject.cadencetype.label }}
                            </h5>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col md="6">
                        <b-row>
                          <b-col md="8">
                            <h4 class="planDetailHeading">
                              Unit Of Measurement:
                            </h4>
                          </b-col>
                          <b-col md="4">
                            <h5 class="plandetailResult">
                              {{ inputObject.uom.label }}
                            </h5>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </div>
                </v-card>
              </b-col>
            </b-row>
            <v-card class="mb-3" style="border-radius: 16px">
              <div class="m-2 p-3">
                <h4 style="color: #727cf5">Provisioning</h4>
                <b-row>
                  <b-col md="4">
                    <b-row>
                      <b-col md="4">
                        <h4 class="planDetailHeading">Plan Access:</h4>
                      </b-col>
                      <b-col md="8">
                        <h5 class="plandetailResult">
                          {{ inputObject.planAccess.label }}
                        </h5>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col md="4">
                    <b-row>
                      <b-col md="4">
                        <h4 class="planDetailHeading">Plan Type:</h4>
                      </b-col>
                      <b-col md="8">
                        <h5 class="plandetailResult">
                          {{ inputObject.planType.label }}
                        </h5>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col md="4">
                    <b-row>
                      <b-col md="3">
                        <h4 class="planDetailHeading">Validity:</h4>
                      </b-col>
                      <b-col md="9">
                        <h5 class="plandetailResult">
                          {{ inputObject.validity }}
                        </h5>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="4" v-if="inputObject.planType.value === 'LIMITE'">
                    <b-row>
                      <b-col md="4">
                        <h4 class="planDetailHeading">Plan Type:</h4>
                      </b-col>
                      <b-col md="8">
                        <h5 class="plandetailResult">
                          {{ inputObject.planType.label }}
                        </h5>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col md="4">
                    <b-row>
                      <b-col md="4">
                        <h4 class="planDetailHeading">Features:</h4>
                      </b-col>
                      <b-col md="8">
                        <h5
                          class="plandetailResult"
                          v-for="(e, idx) in inputObject.planFeatures"
                          :key="idx"
                        >
                          {{ e.planFeatures }}
                        </h5>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
            </v-card>
          </div>
          <!-- </v-card> -->
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.esm";
import { Switch as cSwitch } from "@coreui/vue";
import cInput from "@/components/Common/CustomInput";
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import subscriptionplanDetails from "@/components/MasterSetup/subscriptionplan/SubscriptionplanDetails";
import { mapGetters } from "vuex";
import loader from "@/components/loader/nipigeloader.vue";

export default {
  name: "EditSubscription",
  components: {
    ebButton,
    cSwitch,
    cInput,
    ValidationProvider,
    ValidationObserver,
    ebSelect,
    subscriptionplanDetails,
    loader,
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      show: true,
      loading: false,
      currentProvider: "",

      status: true,
      timingRules: [
        {
          within: "",
          totalLimit: "",
        },
      ],
      inputObject: {
        autoRenewal: true,
        cadencetype: "",
        scope: "",
        orgAccessLevel: "",
        orgAccessList: "",
        planName: "",
        taxCode: "",
        chargeCode: "",
        description: "",
        planType: "",
        isActive: true,
        planlimit: "",
        validity: "",
        planAccess: "",
        paymentType: "",
        cadencetype: "",
        eventType: "",
        price: "",
        currency: "",
        baseQuantity: "",
        uom: "",
        planFeatures: [
          {
            planFeatures: "",
            isRemovable: false,
            text: "Add",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      provider: "auth/getUserID",
    }),
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
    orgAccessListOptions() {
      let data = this.$store.getters["partner/GetPartnerList"];
      let tenantList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          if (this.inputObject.orgAccessLevel.value === "LIMITED") {
            let arrayObj = {
              keys: obj._id,
              name: obj.authentication.userName,
              ...obj,
            };
            tenantList.push(arrayObj);
          }
        });
        return tenantList;
      } else {
        return [];
      }
    },
    taxcodeoptions() {
      let data = this.$store.getters["taxcode/GetTaxcodeList"];
      if (Array.isArray(data) && data.length > 0) {
        return data.map((d) => ({
          label: d.taxCode,
          value: d._id,
        }));
      }
      return [];
    },
    accessrulesList() {
      let data = this.$store.getters["accessrule/accessRuleList"];

      if (Array.isArray(data) && data.length > 0) {
        return data.map((d) => {
          return {
            label: d.name.toUpperCase(),
            value: d._id,
          };
        });
      }
      return [];
    },
  },
  methods: {
    fetchingAllData() {
      this.inputObject.planName = this.details.planName;
      this.inputObject.scope = {
        label: this.details.scope,
        value: this.details.scope,
      };
      this.inputObject.isActive = this.details.isActive;
      this.inputObject.description = this.details.planDescription;
      let fiterOgroList = [];
      if (this.details.orgAccess.orgAccessLevel) {
        this.inputObject.orgAccessLevel = {
          label: this.details.orgAccess.orgAccessLevel.toUpperCase(),
          value: this.details.orgAccess.orgAccessLevel.toUpperCase(),
        };
      } else {
      }
      if (
        this.details.orgAccess.orgAccessList &&
        this.details.orgAccess.orgAccessLevel == "LIMITED"
      ) {
        this.details.orgAccess.orgAccessList.forEach((obj) => {
          let eachFilteredList = this.orgAccessListOptions.filter((element) => {
            return element._id == obj;
          });
          fiterOgroList.push(eachFilteredList);
        });
      }
      let modifiedOrgodata = [];
      fiterOgroList.forEach((obj) => {
        modifiedOrgodata.push(obj[0]);
      });
      this.inputObject.orgAccessList = modifiedOrgodata;
      this.inputObject.paymentType = {
        label: this.details.paymentType,
        value: this.details.paymentType,
      };
      let taxCodeFilter = this.$store.getters["taxcode/GetTaxcodeList"].filter(
        (obj) => {
          return obj._id == this.details.taxCode;
        }
      );
      if (taxCodeFilter.length > 0) {
        this.inputObject.taxCode = {
          label: taxCodeFilter[0].taxCode,
          value: taxCodeFilter[0]._id,
        };
      } else {
      }
      this.inputObject.chargeCode = this.details.chargeCode;
      this.inputObject.currency = this.details.pricing.currency;
      this.inputObject.cadencetype = {
        label: this.details.pricing.cadence,
        value: this.details.pricing.cadence,
      };
      this.inputObject.eventType = {
        label: this.details.pricing.eventType,
        value: this.details.pricing.eventType,
      };
      this.inputObject.uom = {
        label: this.details.pricing.uom,
        value: this.details.pricing.uom,
      };
      this.inputObject.baseQuantity = this.details.pricing.baseQuantity;
      this.inputObject.price = this.details.pricing.price;
      this.inputObject.autoRenewal = this.details.autoRenewal;
      let accessRuleFilter = this.$store.getters[
        "accessrule/accessRuleList"
      ].filter((obj) => {
        return obj._id == this.details.planAccess;
      });

      if (accessRuleFilter.length > 0) {
        this.inputObject.planAccess = {
          label: accessRuleFilter[0].name.toUpperCase(),
          value: accessRuleFilter[0]._id,
        };
      } else {
      }

      this.inputObject.planType = {
        label: this.details.provisioning.planType,
        value: this.details.provisioning.planType,
      };
      this.inputObject.validity = this.details.provisioning.validity;
      this.inputObject.planlimit = this.details.provisioning.planLimit;
      let firstFeatureKey = true;
      this.inputObject.planFeatures = [];
      this.details.planFeatures.forEach((obj) => {
        if (firstFeatureKey) {
          this.inputObject.planFeatures.push({
            planFeatures: obj,
            isRemovable: false,
            text: "Add",
          });
          firstFeatureKey = false;
        } else {
          this.inputObject.planFeatures.push({
            planFeatures: obj,
            isRemovable: true,
            text: "Remove",
          });
        }
      });
    },
    async onClickEamilButton(item, idx) {
      const { isRemovable } = item;
      if (!isRemovable)
        this.inputObject.planFeatures.push({
          planFeatures: "",
          isRemovable: true,
          text: "Remove",
        });
      else this.inputObject.planFeatures.splice(idx, 1);
    },
  },
  async mounted() {
    this.loading = true;
    //this.getCatalogName();
    this.$store.dispatch("taxcode/fetchTaxcodeListforTenant");
    this.$store.dispatch("partner/fetchPartnersList").then((data) => {
      if (data.message) {
        this.$toasted.error(data.message);
      }
    });
    this.$store.dispatch("role/fetchRoles");
    await this.$store
      .dispatch(
        "taxcode/fetchTaxcodeListforTenant",
        this.$store.getters["auth/getUserID"]
      )
      .then((data) => {
        if (data.message) {
          this.$toasted.error(data.message);
        } else {
        }
      });
    await this.$store
      .dispatch(
        "accessrule/accessRuleList",
        this.$store.getters["auth/getUserID"]
      )
      .then((data) => {
        if (data.message) {
          this.$toasted.error(data.message);
        } else {
        }
      });
    this.fetchingAllData();
    this.loading = false;
  },
};
</script>
<style scoped>
.myDIV:hover + .hide {
  display: block;
  position: absolute;
}
.hide {
  display: none;
  font-size: 11px;
}
.planDetailHeading {
  font-size: 14px;
}
.plandetailResult {
  color: gray;
  font-size: 13px;
}
</style>
